module.exports = __webpack_public_path__ + "static/media/pic3.faf03039.jpg";